import gql from 'graphql-tag';

export const deleteEquipmentMutation = gql(/* GraphQL */ `
  mutation deleteEquipmentMutation($equipmentId: UUID!) {
    deleteEquipment(equipmentId: $equipmentId)
  }
`);
